package com.arena_web.data.repository

import com.arena_web.data.api.ClubPublicApi
import com.arena_web.data.dto.*
import com.arena_web.domain.repositories.ClubPublicRepository

class ClubPublicRepositoryImpl(private val clubPublicApi: ClubPublicApi) : ClubPublicRepository {

    override suspend fun browseClubs(params: Map<String, String>): Result<ClubListPageDto> =
        apiCall { clubPublicApi.browseClubs(params) }

    override suspend fun getClubDetail(clubId: String): Result<PublicClubDetailDto> =
        apiCall { clubPublicApi.getClubDetail(clubId) }

    override suspend fun getSchedule(clubId: String): Result<ClubScheduleDto> =
        apiCall { clubPublicApi.getSchedule(clubId) }

    override suspend fun getFieldPricing(clubId: String, fieldId: String): Result<List<FieldPricingDto>> =
        apiCall { clubPublicApi.getFieldPricing(clubId, fieldId) }

    override suspend fun getFieldAvailability(clubId: String, fieldId: String, params: Map<String, String>): Result<FieldAvailabilityDto> =
        apiCall { clubPublicApi.getFieldAvailability(clubId, fieldId, params) }

    override suspend fun getFeed(clubId: String, params: Map<String, String>): Result<ClubPostPageDto> =
        apiCall { clubPublicApi.getFeed(clubId, params) }

    override suspend fun getReviews(clubId: String, params: Map<String, String>): Result<ClubReviewPageDto> =
        apiCall { clubPublicApi.getReviews(clubId, params) }
}
